// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';

// ANTD
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import notification from 'antd/lib/notification';
// APOLLO
import { graphql } from 'react-apollo';
import connectWithTwilio from 'ApolloClient/Mutations/connectWithTwilio';

const FormItem = Form.Item;

class TwilioConnect extends React.PureComponent {
  state = {
    phone: '',
    loading: false,
    showForm: false,
    disabled: false, // whether or not the form submit button is disabled
  };

  disableBtn = () => {
    this.setState({ disabled: true });
  };

  enableBtn = () => {
    this.setState({ disabled: false });
  };

  handleSubmit = async evt => {
    evt.preventDefault();

    const { twilioConnect } = this.props;
    const { phone } = this.state;

    this.disableBtn();

    try {
      await twilioConnect({
        // eslint-disable-line
        variables: { phone },
        // refetchQueries: [{ query: GET_USER_DATA }],
      });

      this.setState({ phone: '', showForm: false });
      notification.success({ message: 'Number saved!' });
    } catch (exc) {
      console.log(exc);
      notification.error({ message: exc });
    }
    this.setState({ showForm: false });
    this.enableBtn();
  };

  render() {
    const { user } = this.props;
    const { disabled } = this.state;

    const twilioSet = user.twilio && user.twilio.phone && user.twilio.phone.length > 0;

    let showForm = this.state.showForm || !twilioSet || !user.twilio.phone;

    return (
      <Form onSubmit={this.handleSubmit} style={{ padding: 10 }}>
        <Row type="flex" gutter={20} align="middle" justify="center" style={{ padding: 5 }}>
          <Col xs={16}>
            {showForm ? (
              <Input
                onChange={e => this.setState({ phone: e.target.value })}
                value={this.state.phone}
                placeholder="e.g. '5555555555'"
                size="large"
              />
            ) : (
              <div>Current Number: {user.twilio.phone}</div>
            )}
          </Col>
          <Col xs={8}>
            {showForm ? (
              <Button htmlType="submit" type="primary" disabled={disabled || this.state.loading}>
                {`${twilioSet ? 'Save' : 'Add'} Phone Number`}
              </Button>
            ) : (
              <a onClick={() => this.setState({ showForm: true })}>Change Phone Number</a>
            )}
          </Col>
        </Row>
      </Form>
    );
  }
}

TwilioConnect.propTypes = {
  user: PropTypes.shape({
    twilio: PropTypes.shape({
      phone: PropTypes.string,
    }),
  }).isRequired,
  twilioConnect: PropTypes.func.isRequired,
};

export default graphql(connectWithTwilio, { name: 'twilioConnect' })(TwilioConnect);



// WEBPACK FOOTER //
// ./src/routes/app-studio/AlertsArea/TwilioConnect/index.js